import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

const fadeOutPastDates = (date) => {
  const isToday = date.toDateString() === new Date().toDateString();
  const isFutureDate = date > new Date();
  const dateClass = isToday || isFutureDate ? '' : 'ui-datepicker-past-date';

  return [true, dateClass];
};

// jQuery UI datepicker options: the team's date format and faded past dates. Every file that
// creates a datepicker imports this module, so the defaults are in place first. Applied again
// after a Turbo visit, whose re-run CDN jQuery UI comes back with its own defaults.
onPageLoad(() => {
  // The onboarding layout boots Stimulus without jQuery.
  if (!window.jQuery?.datepicker) {
    return;
  }

  $.datepicker.setDefaults({
    dateFormat: $('meta[name=date-format]').attr('content'),
    beforeShowDay: fadeOutPastDates,
  });
});
